var map = {
	"./Add_doctor_to_Fav.jpg": "lC01",
	"./Appointment_Listing_and_Encounter_Status.jpg": "3w0a",
	"./Booked_appointment.png": "y6Qg",
	"./Build_Treatment_Plan_Repository.jpg": "C6/Y",
	"./Cancel_an_Appointment_for_a_Patient.jpg": "Hneq",
	"./Complaint.jpeg": "Mgxe",
	"./Encounter.jpeg": "dzF7",
	"./Encounter_a_Patient_for_Consultation.jpg": "8sJ7",
	"./Enhance_Your_Profile.jpg": "HZ9I",
	"./Hospital's_Affiliated_Doctors.jpg": "Uzll",
	"./Inform_about_leave_absence.jpg": "McBQ",
	"./Knee Xpert Opinion .svg": "mi3s",
	"./Kx_header.svg": "7ATU",
	"./Login_banner.png": "MZqJ",
	"./Patient_Appointment_Schedule.jpg": "J+t2",
	"./Patient_Encounter_History_Management.jpg": "JUOF",
	"./Patient_List_in_Hospitals.jpg": "PgIw",
	"./Patient_Transaction_Log.jpg": "2bnP",
	"./QRCode.jpg": "x9wK",
	"./Record_Vitals_for_a_Patient.jpg": "fXfJ",
	"./Record_vitals.jpg": "z2wa",
	"./Reschedule_an_Appointment.jpg": "TDlP",
	"./Reschedule_an_Appointment_for_a_Patient.jpg": "andu",
	"./Update_Profile_and_Information.jpg": "rBDM",
	"./Upload_a_Medical_Record.jpg": "Ry9I",
	"./Youtube-icon.svg": "mPIe",
	"./add_family_member.jpg": "vPjn",
	"./automate.jpeg": "NWg+",
	"./background_banner.jpg": "3Xvk",
	"./banner-1.png": "8NoG",
	"./banner-2.jpg": "MsBi",
	"./banner-3.jpg": "ctal",
	"./blog-1.jpg": "oEu5",
	"./blog-2.jpg": "/OQo",
	"./blog-3.jpg": "Ldd6",
	"./blog-4.jpg": "PdSb",
	"./blog/blog-01.jpg": "1beD",
	"./blog/blog-02.jpg": "hMvC",
	"./blog/blog-03.jpg": "U8Oj",
	"./blog/blog-04.jpg": "0LTs",
	"./blog/blog-05.jpg": "8LrS",
	"./blog/blog-06.jpg": "mfiv",
	"./blog/blog-07.jpg": "l4Y5",
	"./blog/blog-08.jpg": "6W9o",
	"./blog/blog-09.jpg": "lSWk",
	"./blog/blog-10.jpg": "QgXW",
	"./blog/blog-thumb-01.jpg": "A2PH",
	"./blog/blog-thumb-02.jpg": "kBbC",
	"./blog/blog-thumb-03.jpg": "Pze+",
	"./blog/blog-thumb-04.jpg": "gIlT",
	"./blog/blog-thumb-05.jpg": "6iM+",
	"./blog/blog-thumb-06.jpg": "qxxK",
	"./blog/blog-thumb-07.jpg": "J/5g",
	"./blog/blog-thumb-08.jpg": "mqTq",
	"./blog/blog-thumb-09.jpg": "PrQ0",
	"./blog/blog-thumb-10.jpg": "mm/g",
	"./blog/blog-wrap-01.jpg": "lvqh",
	"./blog/blog-wrap-02.jpg": "UMnl",
	"./blog/blog-wrap-03.jpg": "ZRCf",
	"./blog/blog-wrap-04.jpg": "i1B6",
	"./blur_banner.avif": "o16U",
	"./cancel_appointment.jpg": "9nyJ",
	"./category/1.png": "RiUC",
	"./category/2.png": "3Zc0",
	"./category/3.png": "6Y2b",
	"./category/4.png": "44RM",
	"./category/5.png": "tAdg",
	"./category/doc-sel-01.jpg": "mh9f",
	"./clinic/clinic-1.jpg": "HHQx",
	"./clinic/clinic-10.jpg": "HBV0",
	"./clinic/clinic-2.jpg": "E/AY",
	"./clinic/clinic-3.jpg": "o7WC",
	"./clinic/clinic-4.jpg": "N91M",
	"./clinic/clinic-5.jpg": "YHDC",
	"./clinic/clinic-6.jpg": "rrOY",
	"./clinic/clinic-7.jpg": "3iCc",
	"./clinic/clinic-8.jpg": "tITc",
	"./clinic/clinic-9.jpg": "Nz8d",
	"./clinic/spec-01.jpg": "MLx7",
	"./clinic/spec-02.jpg": "BFjl",
	"./clinic/spec-03.jpg": "d+xg",
	"./collaboration.jpeg": "TUDg",
	"./college.jpg": "psUo",
	"./complain.png": "ti6g",
	"./daughter.jpg": "tTSm",
	"./desccomplain.jpg": "2VID",
	"./digital_storage.jpeg": "DiG1",
	"./doc-slide-1.png": "iove",
	"./doctor-banner.PNG": "HLYj",
	"./doctor-banner1.png": "J0qn",
	"./doctor.png": "zoJu",
	"./doctor_img.png": "mLOA",
	"./doctor_photo.jpeg": "pfpV",
	"./doctor_register.jpg": "mSfy",
	"./doctors/Diagnosis.png": "J22B",
	"./doctors/Diagnosis.svg": "/DUl",
	"./doctors/Doctor Profile.jpg": "Sxfz",
	"./doctors/Doctor Profile.svg": "Qg4b",
	"./doctors/Exercise plan.svg": "Q2tH",
	"./doctors/Exercise_Plan.jpg": "REBU",
	"./doctors/General Advice.png": "mOCc",
	"./doctors/General Advice.svg": "mS2t",
	"./doctors/Hospital.svg": "gKJM",
	"./doctors/Investigation.png": "CzQR",
	"./doctors/Investigation.svg": "TLrE",
	"./doctors/Prescription.jpg": "/0q4",
	"./doctors/Prescription.svg": "HsfE",
	"./doctors/Surgeon.svg": "A8At",
	"./doctors/Surgery.svg": "0K+g",
	"./doctors/Surgery_Icon.jpg": "pS41",
	"./doctors/Symptoms.png": "eChZ",
	"./doctors/Symptoms.svg": "9UEa",
	"./doctors/Treatment Plan.svg": "ma1+",
	"./doctors/book-doc-01.jpg": "rKEh",
	"./doctors/book-doc-02.jpg": "6KdA",
	"./doctors/book-doc-03.jpg": "CMNc",
	"./doctors/book-doc-04.jpg": "+0k6",
	"./doctors/book-doc-05.jpg": "XSGY",
	"./doctors/doctor-01.jpg": "v0gv",
	"./doctors/doctor-02.jpg": "+C89",
	"./doctors/doctor-03.jpg": "13Ux",
	"./doctors/doctor-04.jpg": "EFGk",
	"./doctors/doctor-05.jpg": "wox+",
	"./doctors/doctor-06.jpg": "PJq/",
	"./doctors/doctor-07.jpg": "1swk",
	"./doctors/doctor-08.jpg": "cp4y",
	"./doctors/doctor-09.jpg": "C4Ea",
	"./doctors/doctor-10.jpg": "cyB0",
	"./doctors/doctor-11.jpg": "yUmo",
	"./doctors/doctor-12.jpg": "Dkdx",
	"./doctors/doctor-thumb-01.jpg": "E8U8",
	"./doctors/doctor-thumb-02.jpg": "iEkO",
	"./doctors/doctor-thumb-03.jpg": "0P2w",
	"./doctors/doctor-thumb-04.jpg": "01w2",
	"./doctors/doctor-thumb-05.jpg": "+fV4",
	"./doctors/doctor-thumb-06.jpg": "iGh0",
	"./doctors/doctor-thumb-07.jpg": "IuEn",
	"./doctors/doctor-thumb-08.jpg": "WM9Z",
	"./doctors/doctor-thumb-09.jpg": "N9Cd",
	"./doctors/doctor-thumb-10.jpg": "qwSq",
	"./doctors/doctor-thumb-11.jpg": "jTgX",
	"./doctors/doctor-thumb-12.jpg": "sl5Z",
	"./doctors/doctor.png": "g3Hb",
	"./doctors/doctorss.jpg": "bWDj",
	"./doctors/exercise.png": "KnEm",
	"./doctors/exercisee.jpg": "AAEK",
	"./doctors/female_doctor.jpg": "wcCq",
	"./doctors/gallary_photo.jpg": "k6o8",
	"./doctors/hospital_img.png": "9wVr",
	"./dr-slider.png": "GrlR",
	"./encounter.jpg": "ushy",
	"./encountera.png": "VdWU",
	"./father.jpg": "WN3v",
	"./favicon.png": "06CR",
	"./featured-bg.jpg": "wMU8",
	"./features/feature-01.jpg": "Ddlh",
	"./features/feature-02.jpg": "Qxok",
	"./features/feature-03.jpg": "glX+",
	"./features/feature-04.jpg": "PhAg",
	"./features/feature-05.jpg": "ddIV",
	"./features/feature-06.jpg": "0gv0",
	"./features/feature.png": "Ag8u",
	"./file.png": "3oot",
	"./finalregistration.png": "ClQ3",
	"./financialmanagement.jpeg": "AUYC",
	"./footer-img.png": "F6q4",
	"./footer-logo.png": "KlX+",
	"./google-map.png": "iSnQ",
	"./healthcare.jpeg": "21NJ",
	"./hospital.png": "iDNs",
	"./hospital_registrations.jpg": "+zOA",
	"./icon-01.png": "d0n1",
	"./icon-02.png": "0S8I",
	"./icon-03.png": "MOFD",
	"./icons/Group.png": "S/92",
	"./icons/browse-01.jpg": "v7kn",
	"./icons/browse-02.jpg": "T/uI",
	"./icons/browse-03.jpg": "jkde",
	"./icons/browse-04.jpg": "jMjQ",
	"./icons/browse-05.jpg": "Qu2b",
	"./icons/camera.svg": "KqQ/",
	"./icons/cardiology.png": "Tdm1",
	"./icons/clinic-01.png": "ObAS",
	"./icons/clinic-02.png": "klN3",
	"./icons/clinic-03.png": "YkyE",
	"./icons/clinic-04.png": "QZ+y",
	"./icons/clinic-05.png": "QC8O",
	"./icons/clinic-06.png": "7C6O",
	"./icons/clinic-07.png": "nBXt",
	"./icons/clinic-08.png": "lPD2",
	"./icons/clinic-09.png": "Ulg4",
	"./icons/clinic-10.png": "RW5D",
	"./icons/clinic-11.png": "yD/i",
	"./icons/clinic-12.png": "PXe2",
	"./icons/clinic-13.png": "0ZMY",
	"./icons/clinic-hover-01.png": "Dqzn",
	"./icons/clinic-hover-02.png": "7rSJ",
	"./icons/clinic-hover-03.png": "+acM",
	"./icons/clinic-hover-04.png": "exPI",
	"./icons/clinic-hover-05.png": "JKAg",
	"./icons/clinic-hover-06.png": "xKzF",
	"./icons/clinic-hover-07.png": "FbB0",
	"./icons/clinic-hover-08.png": "Aoqn",
	"./icons/clinic-hover-09.png": "xtR6",
	"./icons/clinic-hover-10.png": "1qeR",
	"./icons/doct-01.png": "FUV0",
	"./icons/doct-02.png": "RRRE",
	"./icons/down-arrow-gray-dark.svg": "OaQL",
	"./icons/down-arrow-gray.svg": "F/N4",
	"./icons/female.png": "MlSL",
	"./icons/male.png": "W0n0",
	"./icons/search-icon.svg": "WReo",
	"./icons/set-cat-01.png": "pL5F",
	"./icons/set-cat-02.png": "yUZo",
	"./icons/set-cat-03.png": "B/3/",
	"./icons/tick-icon.svg": "efwD",
	"./icons/unvisible.svg": "M8P7",
	"./icons/visible.svg": "0Gls",
	"./icons/visit-01.png": "SSZk",
	"./icons/visit-02.png": "79C/",
	"./icons/visit-03.png": "6uDq",
	"./icons/x-icon-01.png": "BAK5",
	"./img-01.jpg": "csuN",
	"./img-02.jpg": "iVX4",
	"./img-03.jpg": "bCtQ",
	"./img-04.jpg": "M3N7",
	"./img-pharmacy1.jpg": "ab+M",
	"./knee_banner.svg": "4k4+",
	"./lab-image.jpg": "+nf9",
	"./loader/100 260/100-V1.gif": "LV3y",
	"./loader/100 260/100.gif": "gc7K",
	"./loader/150 395/150-395-V1.gif": "Ab3U",
	"./loader/150 395/150-395.gif": "ERyW",
	"./loader/70 184/70-V1.gif": "v+Gm",
	"./loader/70 184/70.gif": "i4w6",
	"./loader/GIF1/100-100-V1.gif": "E0ej",
	"./loader/GIF1/100-100.gif": "BijK",
	"./loader/GIF1/150-150-V1.gif": "hoLj",
	"./loader/GIF1/150-150.gif": "i7jI",
	"./loader/GIF2/70-70-V1.gif": "F2gQ",
	"./loader/GIF2/70-70.gif": "YBfs",
	"./loader/healthcare_loader.gif": "qW0w",
	"./location.png": "xnra",
	"./login-banner.png": "XeWC",
	"./login-btn.png": "mJhh",
	"./logo.png": "dLd/",
	"./logo/Banner.svg": "ehAu",
	"./logo/Favicon_Icon.png": "CkSo",
	"./logo/Knee_Xpert_Logo.svg": "/Kkc",
	"./logo/Knee_Xpert_Logo_Reverse.svg": "LSUu",
	"./logo/helthcare_logo.jpeg": "ACZ1",
	"./logo_new.png": "YPs5",
	"./marker.png": "eSNv",
	"./medical-img1.jpg": "cbYJ",
	"./medical-img2.jpg": "JdCt",
	"./medical-img3.jpg": "64qJ",
	"./medicalcollage.jpg": "vMMA",
	"./medicalrecords.jpeg": "AWn0",
	"./mother.jpg": "ZfOK",
	"./multipledoctor.jpeg": "VcCI",
	"./otp_im.svg": "y4rM",
	"./otp_img.svg": "VU+I",
	"./otp_img2.png": "midc",
	"./patient_encounter.jpg": "rex4",
	"./patientportal.jpeg": "/tlg",
	"./patients/Patient Profile.svg": "zwfo",
	"./patients/patient.jpg": "ZuuW",
	"./patients/patient1.jpg": "r7zz",
	"./patients/patient10.jpg": "rTHD",
	"./patients/patient11.jpg": "+tWG",
	"./patients/patient12.jpg": "pECe",
	"./patients/patient13.jpg": "SCJ3",
	"./patients/patient14.jpg": "3Qpv",
	"./patients/patient15.jpg": "pZux",
	"./patients/patient2.jpg": "Gac2",
	"./patients/patient3.jpg": "PpsS",
	"./patients/patient4.jpg": "IkoD",
	"./patients/patient5.jpg": "u5GX",
	"./patients/patient6.jpg": "8Sgi",
	"./patients/patient7.jpg": "5sY3",
	"./patients/patient8.jpg": "CHyk",
	"./patients/patient9.jpg": "OkRT",
	"./perseption.jpeg": "wXHd",
	"./products/product.jpg": "UKVx",
	"./products/product1.jpg": "OXOm",
	"./products/product10.jpg": "2hq3",
	"./products/product11.jpg": "w27u",
	"./products/product12.jpg": "KVwQ",
	"./products/product13.jpg": "Zret",
	"./products/product14.jpg": "VakG",
	"./products/product15.jpg": "Uza3",
	"./products/product2.jpg": "8ZlN",
	"./products/product3.jpg": "CN9U",
	"./products/product4.jpg": "2gUJ",
	"./products/product5.jpg": "OPyU",
	"./products/product6.jpg": "PGQ1",
	"./products/product7.jpg": "K7mR",
	"./products/product8.jpg": "JaSL",
	"./products/product9.jpg": "EXOM",
	"./register_doctor.jpg": "NOvN",
	"./register_patient.jpg": "1NcT",
	"./register_patient_by_doctor.jpg": "+Emz",
	"./schedule_an_appointment_for_a_patient.jpg": "8r6h",
	"./search-bg.png": "kFu3",
	"./search.png": "p1AH",
	"./shapes/alarm.png": "Vkld",
	"./shapes/blog-img01.jpg": "CzsE",
	"./shapes/blog-img01.png": "PMAI",
	"./shapes/blog-img02.jpg": "eQpt",
	"./shapes/blog-img03.jpg": "mMdP",
	"./shapes/bro-01.png": "kIcg",
	"./shapes/bro-02.png": "nTsd",
	"./shapes/bro-03.png": "hDO4",
	"./shapes/bro-04.png": "vluX",
	"./shapes/bro-05.png": "xqXS",
	"./shapes/clinic-bg.png": "lBC1",
	"./shapes/consult.png": "NVMK",
	"./shapes/doc-img-01.jpg": "VjVS",
	"./shapes/doctor-bg.jpg": "LIyH",
	"./shapes/doctor-right-bg.jpg": "hSe7",
	"./shapes/exper.png": "H3Ck",
	"./shapes/graph-01.png": "LMML",
	"./shapes/graph-02.png": "1/GN",
	"./shapes/graph-03.png": "KRpZ",
	"./shapes/graph-04.png": "L4t/",
	"./shapes/map-plus.png": "3GMA",
	"./shapes/shape-1.png": "SDS1",
	"./shapes/shape-2.png": "nmSG",
	"./shapes/shape-3.png": "kmGA",
	"./shapes/shape-4.png": "E3l7",
	"./shapes/spec-01.png": "RZ5N",
	"./shapes/spec-02.png": "/apt",
	"./shapes/spec-03.png": "c/X1",
	"./shapes/spec-04.png": "lUKV",
	"./shapes/spec-05.png": "NPsr",
	"./shapes/spec-06.png": "4bD0",
	"./shapes/spec-07.png": "dAgN",
	"./shapes/spec.png": "3XhU",
	"./share_medical_record.jpg": "8Gwp",
	"./slide1.jpg": "8XQh",
	"./slide2.jpg": "ClwB",
	"./slider-bg.jpg": "hmMf",
	"./slider/1680x820.jpg": "tn5u",
	"./slider/banner-01.jpg": "DLLQ",
	"./slider/banner-02.jpg": "cTR0",
	"./slider/blue-bg.png": "xSKT",
	"./slider/book-doc-01.jpg": "KrG/",
	"./slider/doctor-bg.jpg": "0rqd",
	"./slider/doctor1-bg.jpg": "74CS",
	"./slider/feature-img.jpg": "efVR",
	"./slider/patient-bg.jpg": "Egju",
	"./slider/slider-1.jpg": "QGUJ",
	"./slider/slider-2.jpg": "eNkB",
	"./slider/slider-3.jpg": "a0qs",
	"./slider/slider-4.jpg": "5LSe",
	"./slider/slider-5.jpg": "Aotk",
	"./slider/slider-6.jpg": "ZHnC",
	"./slider/slider-7.jpg": "hn+b",
	"./son.jpg": "5kkw",
	"./special-banner.jpg": "wIq8",
	"./specialist-bg.jpg": "vYPj",
	"./specialities/BMI.jpg": "FFLX",
	"./specialities/BMI.svg": "quKm",
	"./specialities/Blood Pressure.svg": "hdN4",
	"./specialities/Body Temperature.svg": "HW6U",
	"./specialities/Body_temp.jpg": "aO+T",
	"./specialities/Fasting Blood Sugar FBS.svg": "pUkD",
	"./specialities/Fasting_blood_sugar.jpg": "Rn6S",
	"./specialities/Hba1c.jpg": "yrqb",
	"./specialities/Hba1c.svg": "u9rD",
	"./specialities/Height In Feet.svg": "gXSz",
	"./specialities/Platelet.svg": "8jwb",
	"./specialities/Pulse Rate.svg": "JDka",
	"./specialities/Pulse.png": "8dmw",
	"./specialities/Random Blood Sugar RBS.svg": "1EBm",
	"./specialities/Respiratory Rate.svg": "qfpe",
	"./specialities/Weight.jpg": "clM2",
	"./specialities/Weight.svg": "wR1S",
	"./specialities/blood_pressure.png": "KYwm",
	"./specialities/pt-dashboard-01.png": "3zU+",
	"./specialities/pt-dashboard-02.png": "52KZ",
	"./specialities/pt-dashboard-03.png": "Reow",
	"./specialities/pt-dashboard-04.png": "cef2",
	"./specialities/specialities-01.png": "1FeS",
	"./specialities/specialities-02.png": "hKRx",
	"./specialities/specialities-03.png": "MTEk",
	"./specialities/specialities-04.png": "H4sZ",
	"./specialities/specialities-05.png": "VZBi",
	"./upload-icon.png": "yR7c",
	"./upload_a_medical_record_by_doctor.jpg": "B/1Z",
	"./verified.png": "bGrj",
	"./verifydoc.png": "IiSn",
	"./video-call.jpg": "Kzgn",
	"./whatsapp-icon-seeklogo.com.svg": "ewns"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "czpq";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/.*$
// module id = czpq
// module chunks = 0